import { InterestType } from '@/app/subscription-ui/entities/interest.type';
import { SubscriptionData } from '@/app/subscription-ui/entities/subscription-data.interface';
import { SubscriptionState } from '@/app/subscription-ui/entities/subscription-state.enum';
import { Subscription } from '@/app/subscription-ui/entities/subscription.interface';
import { ref, Ref } from '@vue/reactivity';
import { ObjectUtils, SubscriptionEntity, SubscriptionResource } from 'webshop-modules';
import { InterestEntity } from '../../../../modules';
import { CustomEventPublisher } from '../../../../modules/dom/application/custom-event-publisher';
import { CustomEventId } from '../../../../modules/dom/CustomEventId.enum';

export class SubscriptionController {

    private state: Ref<Subscription>;

    public constructor(
        private resource: SubscriptionResource,
        private appData: SubscriptionData,
    ) {
        this.state = ref<Subscription>({
            ...appData,
            displayState: SubscriptionState.Initial,
            requestInProgress: false,
        });
    }

    getState(): Subscription {
        return this.state.value;
    }

    updateStateEmail(data: string): void {
        const clone = ObjectUtils.clone<Subscription>(this.state.value);
        clone.user.email = data;
        this.state.value = clone;
    }

    updateDisplayState(data: SubscriptionState): void {
        const clone = ObjectUtils.clone<Subscription>(this.state.value);
        this.state.value = { ...clone, displayState: data };
    }

    updateProgress(state: boolean): void {
        const clone = ObjectUtils.clone<Subscription>(this.state.value);
        this.state.value = { ...clone, requestInProgress: state };
    }

    public async createSubscription(): Promise<any> {
        this.updateProgress(true);

        try {
            const response = await this.resource.createSubscriptionWith(this.mapToEntityFrom(this.getState()));
            this.updateDisplayState(SubscriptionState.SuccessfulRegistration);
            this.updateProgress(false);
            this.emitRegistrationEventFor(this.getState());

            return response;
        } catch (e) {
            this.updateDisplayState(SubscriptionState.SubscriptionFailed);
            this.updateProgress(false);
            return undefined;
        }
    }

    private emitRegistrationEventFor(state: Subscription) {
        if (state.interest.type === InterestType.Artist) {
            CustomEventPublisher.sendEventWith(CustomEventId.ArtistSubscription);
        }
    }

    private mapToEntityFrom(state: Subscription): SubscriptionEntity {
        const clone: Subscription = ObjectUtils.deepClone(state) as Subscription;
        const interests: InterestEntity[] = [{
            resourceId: clone.interest.resourceId,
            resourceName: clone.interest.resourceName,
            type: clone.interest.type,
        }];
        const response: SubscriptionEntity = {
            userEmail: clone.user.email || '',
            interests,
            removedInterests: [],
        };
        
        if (state.interest.type === InterestType.General && state.interest.resourceId === 0) {
            response.marketingConsent = true;
        }

        return response;
    }

}
